var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroissance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "white",
    stroke: "#17406F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 78.9971C22.0121 78.9971 79.4663 78.9971 77.1094 78.9971C77.6011 78.9971 78 78.5982 78 78.1065C78 77.6148 77.6011 77.2158 77.1094 77.2158H73.7568V39.0923H75.4719C77.1343 39.0923 78.1483 37.2599 77.2671 35.8505L69.2062 22.9921C68.3925 21.6938 66.506 21.6629 65.653 22.9399L57.0471 35.7971C56.1068 37.2013 57.1152 39.0923 58.8075 39.0923H60.4415V77.2158H56.153V49.0487C56.153 47.2483 54.6884 45.783 52.8874 45.783H46.1057C44.3047 45.783 42.84 47.2483 42.84 49.0487V77.2158H38.5551V61.1469C38.5551 59.3465 37.0904 57.8813 35.2894 57.8813H28.5077C26.7067 57.8813 25.2421 59.3465 25.2421 61.1469V77.2158H21.8906C21.3989 77.2158 21 77.6148 21 78.1065C21 78.5982 21.3989 78.9971 21.8906 78.9971ZM61.3321 37.3111H58.8075C58.5382 37.3111 58.3766 37.0119 58.5269 36.7875L67.1339 23.9297C67.2605 23.7406 67.5583 23.7169 67.6975 23.9389L75.7572 36.7962C75.8983 37.0213 75.7376 37.3111 75.4719 37.3111H72.8661C72.3745 37.3111 71.9755 37.71 71.9755 38.2017V77.2158H62.2227V38.2017C62.2227 37.71 61.8238 37.3111 61.3321 37.3111ZM44.6213 49.0487C44.6213 48.2299 45.2869 47.5643 46.1057 47.5643H52.8874C53.7061 47.5643 54.3718 48.2299 54.3718 49.0487V77.2158H44.6213V49.0487ZM27.0233 61.1469C27.0233 60.3282 27.689 59.6625 28.5077 59.6625H35.2894C36.1082 59.6625 36.7738 60.3282 36.7738 61.1469V77.2158H27.0233V61.1469Z",
    fill: "#17406F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroissance);
export default __webpack_public_path__ + "static/media/croissance.01f213122722980fdf124eeff74519fe.svg";
export { ForwardRef as ReactComponent };